export class PLDataReq {
  constructor(
    public userId: string,
    public password: string
  ) {}
}

export class PostLoginReq {
  constructor(
    public data: PLDataReq
  ) {
  }
}
